import { z } from 'zod/v4';

export const RemoveCompanyParamsSchema = z.object({
  id: z.string().min(1, 'Company ID is required'),
});

export type RemoveCompanyParams = z.infer<typeof RemoveCompanyParamsSchema>;
